export const extractUrlFromFile = (file) => file?.originFileObj?.url || file?.url;
